import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BlobServiceClient,
  BlobUploadCommonResponse,
} from '@azure/storage-blob';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AIImageUploadService {
  private containerName = 'images';
  private blobServiceClient: BlobServiceClient;

  constructor(private http: HttpClient, private authService: AuthService) {}

  uploadFile(
    file: File,
    sasToken: string,
    fodlername:string,
    progressCallback: (progress: number) => void
  ): Observable<void> {
    this.blobServiceClient = new BlobServiceClient(
      `https://droneimagescaims.blob.core.windows.net?${sasToken}`
    );
    return this.performUpload(file,fodlername, progressCallback);
  }

  private performUpload(
    file: File,
    folderName:string,
    progressCallback: (progress: number) => void
  ): Observable<void> {
    return new Observable((observer) => {
      const containerClient = this.blobServiceClient.getContainerClient(
        this.containerName
      );
      const blobClient = containerClient.getBlockBlobClient(
        folderName+'/'+file.name
      );
      blobClient
        .uploadData(file, {
          blobHTTPHeaders: { blobContentType: file.type },
          onProgress: (progress) => {
            const percent = progress.loadedBytes / file.size;
            progressCallback(percent);
          },
        })
        .then((response: BlobUploadCommonResponse) => {
          if (
            response._response.status >= 200 &&
            response._response.status < 300
          ) {
            observer.next();
            observer.complete();
          } else {
            observer.error(
              new Error(
                'Upload failed with status: ' + response._response.status
              )
            );
          }
        })
        .catch((err) => observer.error(err));
    });
  }
}
